import { forwardRef } from 'react';
import cx from 'classnames';
import { clamp } from 'lodash';

// @ts-expect-error - CustomLinearProgress doesn't have TypeScript definitions
import { CUSTOM_BUTTON_SIZE } from 'src/components/CustomButton';
// @ts-expect-error - CustomLinearProgress doesn't have TypeScript definitions
import { CustomLinearProgress } from 'src/components/CustomLinearProgress';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';

import { useStyles } from './useStyles';

interface Props {
  className?: string;
  progress?: number;
  text?: string;
  size?: string; // TODO: replace with CUSTOM_BUTTON_SIZE type when CustomButton will be converted to TypeScript
}

export const ButtonLikeProgressBar = forwardRef<HTMLDivElement, Props>(
  (
    {
      className,
      progress = 0,
      text = 'Generating...',
      size = CUSTOM_BUTTON_SIZE.medium,
      ...restProps
    },
    ref
  ) => {
    const styles = useStyles({ size });

    const value = clamp(progress, 0, 100);

    return (
      <div
        className={cx(styles.root, className)}
        ref={ref}
        {...restProps}
      >
        <CustomLinearProgress
          className={styles.linearProgress}
          classes={{ bar: styles.bar }}
          variant="determinate"
          value={value}
        />

        <CustomTypography
          className={styles.text}
          variant={TYPOGRAPHY_VARIANT.medium14}
        >
          {text}
        </CustomTypography>
      </div>
    );
  }
);
